import { render, staticRenderFns } from "./ProductoLogisticaList.vue?vue&type=template&id=2aa663a0&scoped=true&"
import script from "./ProductoLogisticaList.vue?vue&type=script&lang=js&"
export * from "./ProductoLogisticaList.vue?vue&type=script&lang=js&"
import style0 from "./ProductoLogisticaList.vue?vue&type=style&index=0&id=2aa663a0&lang=scss&scoped=true&"
import style1 from "./ProductoLogisticaList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ProductoLogisticaList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa663a0",
  null
  
)

export default component.exports